export default function ProductCategory() {
  return (
    <div className="container mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">Product Categories</h1>
      <ul className="list-disc pl-6 text-gray-700">
        <li>Seed</li>
        <li>Chemicals</li>
        <li>Fertilizers</li>
        <li>Machinery</li>
      </ul>
    </div>
  );
}
